import React from "react";
import PropTypes from "prop-types";
import { Box, Flex } from "rebass";
import { Container } from "@components/atoms";
import { Skill } from "@components/molecules";

export const InfoBlock = ({ data }) => {
  return (
    <Container>
      <Flex mx="-1.5rem" flexWrap="wrap">
        {data.map((item) => (
          <Box width={[1 / 2, null, null, 1 / 4]} px="1.5rem" key={item.title} mb="2rem">
            <Skill info {...item} />
          </Box>
        ))}
      </Flex>
    </Container>
  );
};

InfoBlock.propTypes = {
  data: PropTypes.array.isRequired,
};
